export const DATA_MANAGER_EVENTS = {
    CHANGE_DATA: 'changedata',
    CHANGE_DATA_KEY: 'changedata-',
    DESTROY: 'destroy',
    REMOVE_DATA: 'removedata',
    SET_DATA: 'setdata'
};
